<template>
  <div>
    <o-section :overlay="true">
      <div class="u-center">
        <p><strong>Elektronisch rijbewijs</strong></p>
        <p>
          Het rijbewijsnummer komt overeen met het nummertje 5 op je
          elektronisch rijbewijs.
        </p>
        <p>
          <img
            src="/images/driver-info-1.svg"
            class="c-card-example"
            width="198"
            alt="Driver's License"
          />
        </p>
        <p><strong>Papieren rijbewijs</strong></p>
        <p>
          Het rijbewijsnummer vind je terug aan de binnenkant van het rijbewijs.
        </p>
        <p>
          <img
            src="/images/driver-info-2.svg"
            class="c-card-example"
            width="276"
            alt="Driver's License"
          />
        </p>
      </div>
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'ODriverInfo'
}
</script>
